<template>
  <v-container class=" pa-1 pa-sm-4" fluid>
    <v-row>
      <v-col sm="12" md="9" class="pb-0 pt-0 text-end">
        <v-btn
          class="ma-2"
          elevation="4"
          color="primary"
          @click="handleOnNewAddOne"
        >
          <v-icon>mdi-plus-thick</v-icon>
        </v-btn>
        <v-btn
          class="ma-2"
          elevation="4"
          color="error"
          @click="handleOnDeleteAddOne"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="9" class="pb-0 pt-0">
        <v-card>
          <v-list v-if="!isShowAddOne" disabled>
            <v-subheader><h2>零組件類別</h2></v-subheader>
            <v-list-item-group>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="addoneListLabel"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-list v-else>
            <v-subheader><h2>零組件類別</h2></v-subheader>
            <v-list-item v-for="(item, i) in visiblePages" :key="i">
              <!--  -->
              <v-list-item-action>
                <v-checkbox
                  :value="item.id"
                  v-model="checkboxSelected"
                ></v-checkbox>
              </v-list-item-action>
              <!--  -->
              <v-list-item-content>
                <h4>
                  {{ item.name }}
                </h4>
                <!-- <v-list-item-title
                  v-text="item.name"
                  color="error"
                ></v-list-item-title> -->
              </v-list-item-content>
              <!--  -->
              <v-list-item-action>
                <v-btn elevation="4" @click="handleOnEditAddOne(item)" icon>
                  <v-icon color="gray">mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="9">
        <v-pagination
          @input="checkboxSelected = []"
          v-model="page"
          :length="Math.ceil(addones.length / perPage)"
        ></v-pagination>
      </v-col>
    </v-row>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3>{{ dialogTitle }}</h3>
        </v-card-title>
        <v-card-text>
          <v-form v-model="dialogInputValid" @submit.prevent="">
            <v-text-field
              v-model="addone"
              :label="dialogInputLabel"
              :rules="addoneRules"
              :counter="10"
              required
            >
            </v-text-field>
            <v-switch
              v-model="addoneEnb"
              inset
              color="primary"
              :label="`狀態:${addoneEnb ? '啟用' : '關閉'}`"
            ></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn elevation="4" color="error" @click="dialog = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-end">
              <v-btn
                elevation="4"
                color="success"
                @click="handleOnDialogSave"
                :disabled="isSending"
              >
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-progress-linear
          :active="isSending"
          indeterminate
          absolute
          bottom
        ></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    addone: '',
    addoneListLabel: '暫無資料',
    addoneEnb: false,
    addoneRules: [
      v => !!v || '不可空白',
      v => v.length <= 10 || '字數不可超過10個字'
    ],
    isShowAddOne: false,
    perPage: 5,
    page: 1,
    checkboxSelected: [],
    dialog: false,
    dialogTitle: '新增類別',
    dialogInputLabel: '',
    dialogOnSaveFn: undefined,
    dialogInputValid: false
  }),
  computed: {
    ...mapState('account', ['uid']),
    ...mapState('admin', ['addones', 'isSending']),
    visiblePages() {
      return this.addones.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      )
    }
  },
  methods: {
    ...mapActions('admin', [
      'getAddOnes',
      'updateAddOnes',
      'saveAddOne',
      'deleteAddOne'
    ]),
    handleOnNewAddOne() {
      this.addone = ''
      this.addoneEnb = 1
      this.dialogTitle = '新增類別'
      this.dialogInputLabel = '零組件類別'
      this.addoneListLabel = '資料更新中...'
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.dialogInputValid) return
        const { addone, uid } = this
        this.isShowAddOne = false
        await this.saveAddOne({ addone, uid, enb: this.addoneEnb ? 1 : 0 })
        this.$nextTick(() => {
          this.isShowAddOne = true
          this.dialog = false
        })
      }
    },
    handleOnDeleteAddOne() {
      if (this.checkboxSelected.length < 1) return
      let res = confirm('確定刪除嗎?')
      if (!res) return
      // eslint-disable-next-line no-console
      // if (process.env.NODE_ENV === 'development') console.log(this.checkboxSelected)
      // eslint-disable-next-line prettier/prettier
      (async () => {
        const { uid } = this
        this.isShowAddOne = false
        this.addoneListLabel = '資料更新中...'
        await this.deleteAddOne({ uid, ids: this.checkboxSelected })
        this.$nextTick(() => {
          this.isShowAddOne = true
        })
      })()
    },
    handleOnEditAddOne(item) {
      this.addone = item.name
      this.addoneEnb = item.enb
      this.dialogTitle = '編輯類別'
      this.dialogInputLabel = '零組件類別'
      this.addoneListLabel = '資料更新中...'
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (!this.dialogInputValid) return
        if (this.addone === item.name && this.addoneEnb * 1 === item.enb) return
        const { addone, uid } = this
        this.isShowAddOne = false
        await this.updateAddOnes({
          addone,
          uid,
          id: item.id,
          enb: this.addoneEnb ? 1 : 0
        })
        this.$nextTick(() => {
          this.isShowAddOne = true
          this.dialog = false
        })
      }
    },
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    }
  },
  async created() {
    const { uid } = this
    await this.getAddOnes({ uid })
    this.$nextTick(() => {
      this.isShowAddOne = true
    })
  }
}
</script>

<style scoped></style>
